import React, { useMemo } from 'react'

export const isValidUser = acceptedFunction =>
  JSON.parse(localStorage.getItem('functions')).includes(acceptedFunction)

export const isValidUserInputMultipleFunctions = acceptedFunctions =>
  JSON.parse(localStorage.getItem('functions')).filter(value => acceptedFunctions.includes(value)).length > 0

export default function OnlyWithFunction({
  acceptedFunction,
  acceptedSecondFunction,
  fallbackComponent = <div />,
  children,
}) {
  const functions = JSON.parse(localStorage.getItem('functions'))

  const canAccess = useMemo(
    () =>
      functions &&
      (functions.includes(acceptedFunction) ||
        functions.includes(acceptedSecondFunction)),
    [functions, acceptedFunction, acceptedSecondFunction]
  );



  return (
    <div>
      {canAccess && children}
      {!canAccess && fallbackComponent}
    </div>
  )
}
